import { getRegion, getEnv } from '@adsk/acs-sc-web-platform-api';

import { getConfig } from './env';
import { VERSION_1, VERSION_2 } from '../consts';

export const getDeepLink = (
  entity: { id: string },
  projectId: string,
  type = '',
  isCustomReviewEnabled = false,
) => {
  const version = isCustomReviewEnabled ? VERSION_2 : VERSION_1;
  const url = `${getConfig(
    getEnv(),
    getRegion(),
    'buildFE',
  )}/submittals/${version}/projects/${projectId}/${type.toLowerCase()}/${
    entity.id
  }`;

  return url;
};
